import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Map from "./Components/Map";
import Home from "./Pages/Home";
import Question from "./Components/Question";
import Consult from "./Pages/Consult";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/map" element={<Map />}/>
        <Route path="/questions" element={<Question />}/>
        <Route path="/segnalatori" element={<Consult />}/>
      </Routes>
    </Router>
  );
}

export default App;
